import { addValidator } from 'redux-form-validators'

const GENERIC_ERROR_MSG =
  'The information entered is not valid. Please update. If you believe this is an error, please contact us.'
const NO_BIRTH_YEAR_MSG =
  'The name entered is not valid. Please update. If you believe this is an error, please contact us.'
const BROKER_LICENSE_NUMBER_INVALID_MSG =
  'The broker license entered is not valid. Please update. If you believe this is an error, please contact us.'

const PHONE_ERROR = 'Enter a valid phone number.'

const validateNoBirthYear = (value = '') => {
  const regex = /^\d{4}$/
  return value.match(regex) ? NO_BIRTH_YEAR_MSG : undefined
}

const validateMaxCharLimit =
  (limit = 0, errorMessage = GENERIC_ERROR_MSG) =>
  (value = '') => {
    return value.length > limit ? errorMessage : undefined
  }

const validateCompanyName = (value = '') => {
  // this is to address an issue where browser autofill can put a birth year in a field where company name is expected
  // reference: https://bugs.chromium.org/p/chromium/issues/detail?id=727740
  return validateNoBirthYear(value)
}

const validateBrokerNumber = (value = '') => {
  const arelloBrokerNumberCharLimit = 12
  return validateMaxCharLimit(
    arelloBrokerNumberCharLimit,
    BROKER_LICENSE_NUMBER_INVALID_MSG
  )(value)
}

const numbersOnly = val => {
  return typeof val === 'string' ? val && val.replace(/[^0-9]/g, '') : ''
}

const numberNoDecimals = (val = '0') => {
  if (typeof val !== 'string') {
    return '0'
  }
  return numbersOnly(
    val.includes('.') ? val.substring(0, val.lastIndexOf('.')) : val
  )
}

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined

const maxValue = max => value =>
  value && value > max ? `Must be less than $${max}` : undefined

const isValidPhone = value => numbersOnly(value).length === 10

const validatePhoneNumber = addValidator({
  defaultMessage: PHONE_ERROR,
  validator: (options, value) => isValidPhone(value),
})

// Matches exactly 10 digits (US phone number, no country code)
const PHONE_REGEX = /^\D*([0-9]{3})\D*([0-9]{3})\D*([0-9]{4})\D*$/

// Validator function for use as pattern in forms
const phonePatternValidator = addValidator({
  defaultMessage: PHONE_ERROR,
  validator: (options, value) => {
    if (typeof value !== 'string') return false
    // Remove all non-digits and check length
    const digits = value.replace(/\D/g, '')
    return PHONE_REGEX.test(value) && digits.length === 10
  },
})

export {
  GENERIC_ERROR_MSG,
  NO_BIRTH_YEAR_MSG,
  BROKER_LICENSE_NUMBER_INVALID_MSG,
  PHONE_ERROR,
  PHONE_REGEX,
  phonePatternValidator,
  numbersOnly,
  numberNoDecimals,
  maxLength,
  maxValue,
  isValidPhone,
  validateNoBirthYear,
  validateMaxCharLimit,
  validateCompanyName,
  validateBrokerNumber,
  validatePhoneNumber,
}
